export { MainPage as default } from "@nvb/ui";
